/* unplugin-vue-components disabled */import { render } from "./upload.vue?vue&type=template&id=c6fc3b1c&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"

import "./upload.vue?vue&type=style&index=0&id=c6fc3b1c&scoped=true&lang=css"
import "./upload.vue?vue&type=style&index=1&id=c6fc3b1c&lang=css"

import exportComponent from "D:\\un-app\\ys_wuxie_webview_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fc3b1c"]])

export default __exports__